globalThis.Card = class Card {
  constructor(options = {}) {
    this.abort = new AbortController();
    this.position = new Vector2();
    this.div = document.createElement("div");
    this.div.classList.add("card");
    this.bar = document.createElement("div");
    this.bar.classList.add("bar");
    this.div.append(this.bar);
    this.title = document.createElement("h3");
    this.title.classList.add("title");
    this.title.innerText = options.title || "Card";
    this.bar.append(this.title);
    if (options.closable !== false) {
      this.close = document.createElement("div");
      this.close.classList.add("close");
      this.bar.append(this.close);
      this.close.addEventListener("click", () => this.remove(), this.abort);
    }
    this.content = document.createElement("div");
    this.content.classList.add("content");
    this.div.append(this.content);
    document.body.append(this.div);
    this.mousedown = false;
    this.div.addEventListener(
      "mousedown",
      this.onMousedown.bind(this),
      this.abort,
    );
    this.bar.addEventListener(
      "mousedown",
      this.onBarMousedown.bind(this),
      this.abort,
    );
    addEventListener("mouseup", this.onMouseup.bind(this), this.abort);
    addEventListener("mousemove", this.onMousemove.bind(this), this.abort);
    this.setPosition(options.x ?? 100, options.y ?? 100);
    if (options.center || options.center_x) this.centerX();
    if (options.center || options.center_y) this.centerY();
  }

  remove() {
    this.abort.abort();
    this.div.remove();
  }

  hide() {
    this.div.style.display = "none";
  }

  show() {
    this.div.style.display = "block";
    this.putOnTop();
  }

  onMousedown(event) {
    event.stopPropagation();
    this.putOnTop();
  }

  onBarMousedown(event) {
    this.mousedown = true;
    this.startcursorpos = new Vector2(event.clientX, event.clientY);
    this.startpos = this.position.clone();
  }

  onMouseup() {
    this.mousedown = false;
  }

  onMousemove(event) {
    if (!this.mousedown) return;
    const delta = new Vector2(event.clientX, event.clientY).sub(
      this.startcursorpos,
    );
    const { x, y } = delta.clone().add(this.startpos);
    this.setPosition(x, y);
  }

  centerX() {
    const size = this.getSize();
    this.setPosition(innerWidth / 2 - size.x / 2, this.position.y);
  }

  centerY() {
    const size = this.getSize();
    this.setPosition(this.position.x, innerHeight / 2 - size.y / 2);
  }

  getSize() {
    const rect = this.div.getBoundingClientRect();
    return new Vector2(rect.right - rect.left, rect.bottom - rect.top);
  }

  setPosition(x, y) {
    this.position.x = x;
    this.position.y = Math.max(globalThis.TOPBAR_HEIGHT, y);
    this.renderPosition();
  }

  renderPosition() {
    this.div.style.setProperty("--x", this.position.x);
    this.div.style.setProperty("--y", this.position.y);
  }

  putOnTop() {
    const cards = document.body.getElementsByClassName("card");
    const last = cards[cards.length - 1];
    if (last !== this.div) last.after(this.div);
  }
};
